@if (!compact()) {
  <ng-content select="[vxSidebarBrand]"></ng-content>
}
<ng-content></ng-content>
